import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import TestCard from "./TestCard";
import "./PaperListing.css";
import Tabs from "./Tabs";
import {
  buildListingSearchWithTab,
  readListingTab,
} from "../../../../../custom_utilities/dashboardBannerNavigation";

export default function PaperListing() {
  const history = useHistory();
  const location = useLocation();
  const { tabs, list, loading } = useSelector((state) => state.aitsTests);
  const [activeTab, setActiveTab] = useState("");

  useEffect(() => {
    if (!tabs?.length) return;
    const requested = readListingTab(location.search);
    setActiveTab(requested && tabs.includes(requested) ? requested : tabs[0]);
  }, [tabs, location.search]);

  const handleTabChange = (tab) => {
    const defaultTab = tabs[0] || "All Tests";
    const nextSearch = buildListingSearchWithTab(location.search, tab, defaultTab);
    setActiveTab(tab);
    if ((location.search || "") === nextSearch) return;
    history.replace({
      pathname: location.pathname,
      search: nextSearch,
      state: location.state,
    });
  };

  const filteredTests = list?.filter((test) => {
    if (activeTab === "All Tests") return true;

    if (activeTab === "Completed") {
      return test.is_submited === 1;
    }

    if (test.tab_name) {
      return test.tab_name === activeTab;
    }

    return true;
  });

  return (
    <div className="paperListingWrapper">
      {tabs.length > 0 && (
        <Tabs tabs={tabs} activeTab={activeTab} setActiveTab={handleTabChange} />
      )}

      <div className="paperListingContent">
        {loading ? (
          <div className="paperListingContent__loader">
            <ClipLoader size={40} color="#C61C26" />
          </div>
        ) : filteredTests.length > 0 ? (
          filteredTests.map((test) => {
            return <TestCard key={test.id} test={test} />;
          })
        ) : (
          <p className="no_tests_text">No tests found.</p>
        )}
      </div>
    </div>
  );
}
